module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-62WD3J0V0V"],"gtagConfig":{"optimize_id":"GTM-W3LJGHS","anonymize_ip":true,"cookie_expires":0},"pluginConfig":{"head":false,"respectDNT":true}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"GTRI Historical Archive","short_name":"GTRI History","icon":"src/images/icons/favicon.ico","start_url":"/","background_color":"#fff","theme_color":"#A4925A","display":"browser","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7c6e0c5e323bc052c584e07b7090b299"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
